import { FtuByVenueInsight } from 'apis/merchant-gateway/insights';
import { InfiniteTable } from 'modules/experience-core';

import { InsightResponsePaginated } from '../../../types';
import { FtuByVenueTableSortableColumnIDs, FtuByVenueTotalItem } from '../types';

const useFtuByVenueTableProps = ({
  isVATEnabled,
  sort,
  setSort,
  ftuByVenueInsights,
  maxRows,
}: {
  isVATEnabled: boolean;
  sort: InfiniteTable.SortState<FtuByVenueTableSortableColumnIDs> | undefined;
  setSort: (sort: InfiniteTable.SortState<FtuByVenueTableSortableColumnIDs> | undefined) => void;
  ftuByVenueInsights: InsightResponsePaginated<FtuByVenueInsight>;
  maxRows: number | undefined;
}) => {
  const {
    data: ftuByVenueData,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
  } = ftuByVenueInsights;

  const pages = ftuByVenueData?.pages ?? [];

  const items = pages.reduce<FtuByVenueTotalItem[]>((res, page) => {
    const { split } = page.data.ftu;
    if (!split) {
      return res;
    }
    return split.reduce((splitRes, item) => {
      if (item.total) {
        const {
          firstTimeCustomersCount,
          returningCustomersCount,
          firstTimeAvgBasketSizeItems,
          returningAvgBasketSizeItems,
          firstTimeAvgBasketSizeWithVat,
          firstTimeAvgBasketSizeNoVat,
          returningAvgBasketSizeWithVat,
          returningAvgBasketSizeNoVat,
        } = item.total;
        return [
          ...splitRes,
          {
            id: item.label ?? '',
            venueName: item.secondaryLabel ?? '',
            firstTimeCustomersCount,
            returningCustomersCount,
            firstTimeAvgBasketSizeItems,
            returningAvgBasketSizeItems,
            firstTimeAvgBasketSize: isVATEnabled ? firstTimeAvgBasketSizeWithVat : firstTimeAvgBasketSizeNoVat,
            returningAvgBasketSize: isVATEnabled ? returningAvgBasketSizeWithVat : returningAvgBasketSizeNoVat,
            currency: page?.currency,
          },
        ];
      }
      return splitRes;
    }, res);
  }, []);

  return {
    fetchingNextPage: isFetchingNextPage,
    fetchingPreviousPage: isFetchingPreviousPage,
    items,
    sort,
    handleSort: (sort: InfiniteTable.SortState<FtuByVenueTableSortableColumnIDs>) => setSort(sort),
    onFetchNextPage: hasNextPage && !maxRows ? fetchNextPage : undefined,
    onFetchPreviousPage: hasPreviousPage && !maxRows ? fetchPreviousPage : undefined,
    visibleRowsCount: maxRows,
  };
};

export default useFtuByVenueTableProps;
